
export default function () {
    const widgetName = 'cardWidget';
    const widgetOpts = cardWidgetOpts;

    return saffire.widgets.cardWidget($(`#${widgetName}`), {
        currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

        cardWidgetLoaded: function (data, owl, hasData) {

            $('.moreButton').attr('target', "")

            if (data.cards.length < 3) {
                $('#cardWidget .card-widget-item:nth-child(1), #cardWidget .card-widget-item:nth-child(2)').wrapAll('<div class="wrap-card">');
                $("#cardWidget .wrap-card").addClass("less-than-three");
            } else {
                $('#cardWidget .card-widget-item:nth-child(2), #cardWidget .card-widget-item:nth-child(3)').wrapAll('<div class="wrap-card">');
            }


        },
        buyNowButton: {
            visible: true,
            text: 'BUY NOW'
        },
        scriptPath: widgetOpts.scriptPath,
        itemsPerPanel: 1,
        hasImages: true,
        imageIsBackground: true,
        link: [], // [], ['all'], ['image', 'title', 'description']
        maxItemsVisible: 3,
        moreButton: {
            visible: true,
            text: 'Learn More'
        },
        showDescription: true,
        slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
        slideshowOptions: {
            items: 1,
            loop: true,
            margin: 10,
            navText: ['Prev', 'Next'],
            nav: true
        },
        textOverImage: true
    });

};